import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface UserState {
  id: string | null
  email: string | null
  name: string | null
}

const initialState: UserState = {
  id: null,
  email: null,
  name: null,
}

const userStore = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState>) => {
      const { email, id, name } = action.payload
      if (!id) return

      state.id = id
      state.email = email
      state.name = name
    },
  },
})

export const { setUser } = userStore.actions

export default userStore.reducer
